export const GET_ASSIGNED_TO = 'getAssignedTo';
export const GET_REPORTEE = 'reportee';
export const SEARCH = 'search'
export const NEW_ASSIGNEE = 'new_assignee'
export const UPLOAD_CSV = 'uploadcsvfile'